var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSentEmailFp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.485 104.5H37.1416C33.5281 104.5 30.1016 102.922 27.7476 100.177C25.3881 97.427 24.3596 93.797 24.9151 90.222L31.7888 46.0706C31.8039 45.9142 31.8281 45.758 31.8616 45.6027L33.0496 37.972C34.0066 31.9 39.1436 27.5 45.2816 27.5H119.625C123.239 27.5 126.665 29.0785 129.019 31.823C131.379 34.573 132.407 38.203 131.852 41.778L130.991 47.3061C130.985 47.6875 130.925 48.0645 130.817 48.4264L123.717 94.028C122.76 100.1 117.623 104.5 111.485 104.5ZM33.0716 91.4925L38.8191 54.5745C38.9278 53.8764 39.7064 53.5081 40.3151 53.8668L71.1039 72.0169C73.4799 73.4139 76.1309 74.1179 78.7819 74.1179C81.0919 74.1179 83.4074 73.5844 85.5414 72.5119L119.779 55.3931C120.506 55.0297 121.339 55.6386 121.214 56.4413L115.561 92.7575C115.247 94.7815 113.531 96.25 111.485 96.25H37.1416C35.9151 96.25 34.8096 95.7385 34.0121 94.8145C33.2146 93.885 32.8846 92.7025 33.0716 91.4925ZM75.2949 64.9109L40.9957 44.6944C40.6427 44.4864 40.4523 44.084 40.5154 43.6791L41.2061 39.2425C41.5196 37.2185 43.2356 35.75 45.2816 35.75H119.625C120.852 35.75 121.957 36.2615 122.755 37.1855C123.552 38.115 123.882 39.2975 123.695 40.5075L123.148 44.0204C123.098 44.3402 122.897 44.6162 122.607 44.761L81.8564 65.1364C79.7609 66.1759 77.3134 66.0989 75.2949 64.9109ZM4.125 46.75H23.375C25.652 46.75 27.5 44.902 27.5 42.625C27.5 40.348 25.652 38.5 23.375 38.5H4.125C1.848 38.5 0 40.348 0 42.625C0 44.902 1.848 46.75 4.125 46.75ZM17.875 68.75H4.125C1.848 68.75 0 66.902 0 64.625C0 62.348 1.848 60.5 4.125 60.5H17.875C20.152 60.5 22 62.348 22 64.625C22 66.902 20.152 68.75 17.875 68.75ZM4.125 90.75H12.375C14.652 90.75 16.5 88.902 16.5 86.625C16.5 84.348 14.652 82.5 12.375 82.5H4.125C1.848 82.5 0 84.348 0 86.625C0 88.902 1.848 90.75 4.125 90.75Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -35.2144,
    y1: 39.6986,
    x2: -12.7695,
    y2: 132.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0130144,
    stopColor: "#FEDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2166,
    stopColor: "#FEC809"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6362,
    stopColor: "#FF9022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5C39"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentEmailFp);
export default __webpack_public_path__ + "static/media/sentEmailFP.22c6e28f6625f167615e0b48e6bf87a7.svg";
export { ForwardRef as ReactComponent };